import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import {
  SOCKET_UNSUBSCRIBE,
  SOCKET_SUBSCRIBE,
  SET_TICKER_INFO,
  ADD_USER_ERROR,
  NOTI_TIMEOUT,
  BASE_URL
} from './types';

export function changePortfolio({ activePortfolioUserId, changePortfolioUserId }) {
  const url = `${BASE_URL()}/api/changeportfolio`;
  const request = axios.post(url, { activePortfolioUserId, changePortfolioUserId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch, getState) => {
    request.then((response) => {
      dispatch({ type: SOCKET_UNSUBSCRIBE, payload: getState().user.tickers });
      dispatch({ type: SET_TICKER_INFO, payload: response });
      dispatch({ type: SOCKET_SUBSCRIBE, payload: getState().user.tickers });
    }).catch(() => {
      NotificationManager.error(`There was an error changing portfolios. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  };
}

export function createNewPortfolio({ name, accountHolder, accountNumber }) {
  const url = `${BASE_URL()}/api/createnewportfolio`;
  const request = axios.post(url, { name, accountHolder, accountNumber }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch, getState) => {
    request.then((response) => {
      dispatch({ type: SOCKET_UNSUBSCRIBE, payload: getState().user.tickers });
      dispatch({ type: SET_TICKER_INFO, payload: response });
      dispatch({ type: SOCKET_SUBSCRIBE, payload: getState().user.tickers });
    }).catch(() => {
      NotificationManager.error(`There was an error creating the new portfolio: ${name}. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  };
}

export function addPortfolioUser({ email, activePortfolioId, userPrivilege }) {
  const url = `${BASE_URL()}/api/addportfoliouser`;
  const request = axios.post(url, { email, activePortfolioId, userPrivilege }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch(addUserError(null));
      dispatch({ type: SET_TICKER_INFO, payload: response });
    }).catch((error) => {
      dispatch(addUserError(error.response.data.error));
    });
  }
}

export function removePortfolioUser({ portfolioUserId, user_id }) {
  const url = `${BASE_URL()}/api/removeportfoliouser`;  
  const request = axios.post(url, { portfolioUserId, user_id }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: SET_TICKER_INFO, payload: response });
    }).catch(() => {
      NotificationManager.error(`There was an error removing the user's portfolio access. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function deletePortfolio({ portfolioId }) {
  const url = `${BASE_URL()}/api/deleteportfolio`;
  const request = axios.post(url, { portfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch, getState) => {  
    request.then((response) => {
      dispatch({ type: SOCKET_UNSUBSCRIBE, payload: getState().user.tickers });
      dispatch({ type: SET_TICKER_INFO, payload: response });
      dispatch({ type: SOCKET_SUBSCRIBE, payload: getState().user.tickers }); 
    }).catch(() => {
      NotificationManager.error(`There was an error deleting the portfolio. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function addUserError(error) {
  return {
    type: ADD_USER_ERROR,
    payload: error
  };
}